<template>
    <div>
        <loader v-if="loading" />
        <div v-else-if="noData">
            <v-row>
                <v-col>
                    Der er ikke blevet uploadet nogen emner på dette projekt i den valgte periode.
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col class="text-right">
                    <v-btn-toggle v-model="selectedCardGroup" mandatory>
                        <v-btn v-for="(group, index) in cardGroups" :key="index">
                            {{ group }}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3" v-for="({ header, value, formatter }, index) in totalCards[selectedCardGroup]" :key="index">
                    <total-card :header="header" :value="value(totals)" :formatter="formatter" :loading="loading" />
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
                <v-col>
                    <v-btn-toggle v-model="numberFormat">
                        <v-btn value="count">
                            Antal
                        </v-btn>
                        <v-btn value="percentage">
                            Procent
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
                <v-col class="text-right">
                    <v-btn-toggle v-model="selectedFieldGroup" mandatory>
                        <v-btn v-for="(group, index) in fieldGroups" :key="index">
                            {{ group.text }}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <v-card>
                <sales-pivot
                    defaultSort="totalCount"
                    :dataObject="stats"
                    :fields="filteredFields"
                    :nestedFields="nestedFields"
                    :valueFunctions="valueFunctions"
                    :equalCols="true" />
            </v-card>
        </div>
    </div>
</template>

<script>
import SalesPivot from '@/components/salesPivot.vue'
import TotalCard from '@/components/totalCard'
import { debounce } from 'debounce'

export default {
    components: {
        SalesPivot,
        TotalCard
    },
    props: {
        tag: String
    },
    data () {
        return {
            numberFormat: 'count',
            loading: true,
            selectedCardGroup: 0,
            cardGroups: ['Emnebehandling', 'Salg'],
            selectedFieldGroup: 0,
            fieldGroups: [
                {
                    text: 'Status',
                    fields: ['totalCount', 'open', 'closed']
                },
                {
                    text: 'Åbne',
                    fields: ['totalCount', 'open', 'newCount', 'attemptedOpenCount', 'redialCount']
                },
                {
                    text: 'Afsluttede',
                    fields: ['totalCount', 'closed', 'errorCount', 'notInterestedCount', 'successCount', 'maxCallsCount', 'expiredCount']

                },
                {
                    text: 'Møder',
                    fields: ['totalCount', 'totalCountBooking', 'openCountBooking', 'closedCountBooking']
                },
                {
                    text: 'Salg',
                    fields: ['totalCount', 'totalSalesCount', 'avgLead', 'avgUploaded', 'avgSale', 'total', 'totalBooking']
                }
            ],
            firstRow: 'Campaign.Name',
            secondRow: 'UserLastLock.Name',
            rows: [
                {
                    text: 'Kampagne',
                    value: 'Campaign.Name'
                },
                {
                    text: 'Agentur',
                    value: 'UserLastLock.Name'
                }
            ],
            stats: null,
            totalCards: [
                [{
                    header: 'Uploadede',
                    formatter: this.$options.filters.separator,
                    value: v => v.totalCount
                },
                {
                    header: 'Åbne emner',
                    formatter: this.$options.filters.separator,
                    value: v => v.totalCount ? (v.newCount + v.attemptedOpenCount + v.redialCount) : 0
                },
                {
                    header: 'Ubehandlede emner',
                    formatter: this.$options.filters.separator,
                    value: v => v.newCount
                },
                {
                    header: 'Forsøgt kontaktet total',
                    formatter: this.$options.filters.separator,
                    value: v => v.attemptedOpenCount + v.notInterestedCount + v.successCount + v.errorCount + v.redialCount
                },
                {
                    header: 'Afsluttet med kontakt',
                    formatter: this.$options.filters.separator,
                    value: v => v.successCount + v.notInterestedCount + v.errorCount
                },
                {
                    header: 'Afsluttet uden kontakt',
                    formatter: this.$options.filters.separator,
                    value: v => v.expiredCount + v.maxCallsCount
                },
                {
                    header: 'Kontaktprocent',
                    formatter: this.$options.filters.percentage,
                    value: v => v.totalCount ? (v.successCount + v.notInterestedCount + v.errorCount + v.redialCount) / v.totalCount : 0
                },
                {
                    header: 'Afslutningsprocent',
                    formatter: this.$options.filters.percentage,
                    value: v => (v.successCount + v.notInterestedCount + v.errorCount) / v.totalCount
                }],
                [{
                    header: 'Uploadede',
                    formatter: this.$options.filters.separator,
                    value: v => v.totalCount
                },
                {
                    header: 'Salg pr. afsluttet',
                    formatter: this.$options.filters.separator,
                    value: v => (v.total + v.totalBooking) / ((v.successCount + v.notInterestedCount + v.errorCount) || 1)
                },
                {
                    header: 'Salg pr. uploaded',
                    formatter: this.$options.filters.separator,
                    value: v => (v.total + v.totalBooking) / ((v.totalCount) || 1)
                },
                {
                    header: 'Total præmie',
                    formatter: this.$options.filters.separator,
                    value: v => v.total + v.totalBooking
                },
                {
                    header: 'Antal salg',
                    formatter: this.$options.filters.separator,
                    value: v => v.successCount + v.salesCountBooking
                },
                {
                    header: 'Hitrate pr. afsluttet',
                    formatter: this.$options.filters.percentage,
                    value: v => (v.successCount + v.salesCountBooking) / ((v.successCount + v.notInterestedCount + v.errorCount + v.maxCallsCount + v.expiredCount) || 1)
                },
                {
                    header: 'Hitrate pr. uploaded',
                    formatter: this.$options.filters.percentage,
                    value: v => (v.successCount + v.salesCountBooking) / ((v.totalCount) || 1)
                }]
            ],
            updateFilteredFields: false,
            valueFunctions: {
                totalCount: v => v.totalCount,
                newCount: v => this.percentageFormat ? v.newCount / v.totalCount : v.newCount,
                open: v => this.percentageFormat ? (v.newCount + v.attemptedOpenCount + v.redialCount) / v.totalCount : (v.newCount + v.attemptedOpenCount + v.redialCount),
                closed: v =>  (v.successCount + v.notInterestedCount + v.errorCount + v.maxCallsCount + v.expiredCount) / ((this.percentageFormat * v.totalCount) || 1),
                attemptedOpenCount: v => v.attemptedOpenCount / ((this.percentageFormat * (v.newCount + v.attemptedOpenCount + v.redialCount)) || 1),
                successCount: v => v.successCount / ((this.percentageFormat * v.totalCount) || 1),
                notInterestedCount: v => v.notInterestedCount / ((this.percentageFormat * (v.successCount + v.notInterestedCount + v.errorCount + v.maxCallsCount + v.expiredCount)) || 1),
                errorCount: v => v.errorCount / ((this.percentageFormat * (v.successCount + v.notInterestedCount + v.errorCount + v.maxCallsCount + v.expiredCount)) || 1),
                redialCount: v => v.redialCount / ((this.percentageFormat * (v.newCount + v.attemptedOpenCount + v.redialCount)) || 1),
                maxCallsCount: v => v.maxCallsCount / ((this.percentageFormat * (v.successCount + v.notInterestedCount + v.errorCount + v.maxCallsCount + v.expiredCount)) || 1),
                expiredCount: v => v.expiredCount / ((this.percentageFormat * v.totalCount) || 1),
                avgLead: v => (v.total + v.totalBooking) / ((v.successCount + v.notInterestedCount + v.errorCount) || 1),
                avgUploaded: v => (v.total + v.totalBooking) / (v.totalCount || 1),
                avgSale: v => (v.total + v.totalBooking) / ((v.successCount + v.salesCountBooking) || 1),
                total: v => v.total,
                attempted: v => v.attemptedOpenCount + v.successCount + v.errorCount + v.redialCount / ((this.percentageFormat * v.totalCount) || 1),
                totalBooking: v => v.totalBooking,
                totalCountBooking: v => v.totalCountBooking / ((this.percentageFormat * v.totalCount) || 1),
                salesCountBooking: v => v.salesCountBooking / ((this.percentageFormat * v.totalCountBooking) || 1),
                closedCountBooking: v => v.closedCountBooking / ((this.percentageFormat * v.totalCountBooking) || 1),
                openCountBooking: v => v.openCountBooking / ((this.percentageFormat * v.totalCountBooking) || 1),
                totalSalesCount: v => (v.successCount + v.salesCountBooking) / (this.percentageFormat * v.totalCount || 1)
            },
            nestedFields: [
                'total',
                'totalCount',
                'newCount',
                'attemptedOpenCount',
                'successCount',
                'notInterestedCount',
                'errorCount',
                'redialCount',
                'maxCallsCount',
                'expiredCount',
                'totalBooking',
                'totalCountBooking',
                'salesCountBooking',
                'openCountBooking',
                'closedCountBooking'
            ]
        }
    },
    computed: {
        fields () {
            return [
                {
                    header: 'Upl.',
                    field: 'totalCount',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Afsl.',
                    field: 'closed',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Åbne',
                    field: 'open',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Ubh.',
                    field: 'newCount',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Aut.',
                    field: 'attemptedOpenCount',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Priv.',
                    field: 'redialCount',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Ukval.',
                    field: 'errorCount',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Nej tak',
                    field: 'notInterestedCount',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Salg',
                    field: 'successCount',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Salg',
                    field: 'totalSalesCount',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Salg pr. afsluttet',
                    field: 'avgLead',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Salg pr. uploaded',
                    field: 'avgUploaded',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Gns. præmie',
                    field: 'avgSale',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Telesalg',
                    field: 'total',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Mødesalg',
                    field: 'totalBooking',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Møder i alt',
                    field: 'totalCountBooking',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Åbne møder',
                    field: 'openCountBooking',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Lukkede møder',
                    field: 'closedCountBooking',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Maks. opkald',
                    field: 'maxCallsCount',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                },
                {
                    header: 'Udløbet',
                    field: 'expiredCount',
                    cols: '2',
                    formatter: this.percentageFormat ? this.$options.filters.percentage : this.$options.filters.separator
                }
            ]
        },
        tab () {
            return this.tabs[this.tabIndex]
        },
        period () {
          return this.$store.state.reports.period  
        },
        range () {
            return this.$store.state.reports.range
        },
        totals() {
            const totals = this.$reduceNested(this.stats, this.nestedFields)
            return {
                ...totals,
                maxDiff: this.maxDiff
            }
        },
        filteredRows () {
            return {
                firstRow: this.rows.filter(row => row.value !== this.secondRow),
                secondRow : this.rows.filter(row => row.value !== this.firstRow),
            }
        },
        filteredFields () {
            if (this.fieldGroup.fields.length) {
                return this.fields.filter(field => {
                    return this.fieldGroup.fields && this.fieldGroup.fields.includes(field.field)
                })
            } else return this.fields
        },
        fieldGroup () {
            return this.fieldGroups[this.selectedFieldGroup]
        },
        percentageFormat () {
            return this.numberFormat === 'percentage'
        },
        groupIndex () {
            return this.$store.state.reports.groupIndex
        },
        report () {
            return this.$store.getters['reports/currentReport']
        }
    },
    methods: {
        async getData () {
            this.loading = true
            // bruger post fordi den sender array
            let response = await this.$http().post('/reports/leads', {
                from: this.range[0],
                to: this.range[1],
                firstKey: this.firstRow,
                secondKey: this.secondRow,
                campaigns: this.$store.getters['reports/campaigns']
            })
            if (response.status === 204) {
                this.stats = {}
                this.noData = true
            }
            else {
                this.stats = response.data
                this.noData = false
            }
            this.loading = false
        },
        switchRows () {
            const tempFirstRow = this.firstRow
            this.firstRow = this.secondRow
            this.secondRow = tempFirstRow
        }
    },
    watch: {
        numberFormat: function () {
            this.loading = true
            requestAnimationFrame(() => {
                requestAnimationFrame(
                    () => {
                        this.loading = false
                })              
            })
            this.updateFilteredFields = !this.updateFilteredFields
        },
		range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
        },
		hours: {
			handler: debounce(function () {
                this.getData();
            }, 1000),
			deep: true
        },
        report: function () {
            this.getData()
        },
        firstRow: function () {
            this.getData()
        },
        secondRow: function () {
            this.getData()
        },
        groupIndex: function () {
            this.getData()
        }
    },
    async created () {
        this.getData()
    }
}
</script>